import { RotatingLines } from "react-loader-spinner";

import type { IRotateLoaderProps } from "@/components/atoms/rotateLoader";
import { useThemeVariable } from "@/theme/useThemeVariable";

/**
 * A rotating loader component using the react-loader-spinner library.
 *
 * @param {IRotateLoaderProps} props - The props for the RotateLoader component.
 * @param {string} [props.color] - The color of the loader (e.g., CSS color value).
 * @param {string} [props.width] - The width of the loader (e.g., CSS width value).
 * @returns RotateLoader The rendered RotateLoader component.
 */
export function RotateLoader({ color, width }: IRotateLoaderProps) {
  const themeColor = useThemeVariable(`--theme-${color}`);

  return (
    // Render the RotatingLines component from react-loader-spinner with animation properties.
    <RotatingLines
      // Animation duration in milliseconds.
      animationDuration={"500ms"}
      // Default width is 20 if not provided.
      width={width || "20"}
      // Color of the rotating lines.
      strokeColor={themeColor?.color}
    />
  );
}
